import { render, staticRenderFns } from "./StringsForEduc.vue?vue&type=template&id=3835f980&scoped=true&"
import script from "./StringsForEduc.vue?vue&type=script&lang=js&"
export * from "./StringsForEduc.vue?vue&type=script&lang=js&"
import style0 from "./StringsForEduc.vue?vue&type=style&index=0&id=3835f980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835f980",
  null
  
)

export default component.exports